// Vỏ app: 5 tab, sub-tab (màn) và accent (UI_SPEC §3.2, §5.3, §18).
// Id tab / màn là tiếng Anh, ổn định; tên hiển thị qua i18n `ui.tab.<tab>`, `ui.screen.<tab>.<screen>`.

export const TAB_IDS = ['character', 'world', 'destiny', 'companions', 'affairs'] as const;
export type TabId = (typeof TAB_IDS)[number];

export type Phase = 'P0' | 'P1' | 'P2' | 'P3';

export interface ScreenDef {
  readonly id: string;
  /** Giai đoạn mở màn (UI_SPEC §18). M0 chỉ dựng placeholder cho mọi màn. */
  readonly phase: Phase;
}

export interface TabDef {
  readonly id: TabId;
  /** Accent của tab, dạng "r,g,b" (UI_SPEC §5.3). */
  readonly accentRgb: string;
  readonly screens: readonly ScreenDef[];
}

export const TABS: readonly TabDef[] = [
  {
    // Theo client tham khảo: tab Nhân Vật không có màn Cơ Duyên (chủ dự án chốt 2026-09-28).
    // Cơ duyên (đốm lửa của Thất Diệm Đăng) sống trong nghi thức Thắp Đèn và ngọn đèn ở màn Tu Luyện.
    id: 'character',
    accentRgb: '114,215,178',
    screens: [
      { id: 'cultivation', phase: 'P0' },
      { id: 'arts', phase: 'P0' },
      { id: 'inventory', phase: 'P0' },
      { id: 'cave', phase: 'P0' },
    ],
  },
  {
    id: 'world',
    accentRgb: '131,191,240',
    screens: [
      { id: 'map', phase: 'P0' },
      { id: 'secretRealm', phase: 'P1' },
      { id: 'forbidden', phase: 'P0' },
      { id: 'challenge', phase: 'P0' },
    ],
  },
  {
    id: 'destiny',
    accentRgb: '223,189,115',
    screens: [
      { id: 'encounter', phase: 'P0' },
      { id: 'quests', phase: 'P0' },
      { id: 'codex', phase: 'P0' },
    ],
  },
  {
    id: 'companions',
    accentRgb: '181,155,233',
    screens: [
      { id: 'summon', phase: 'P1' },
      { id: 'nurture', phase: 'P1' },
      { id: 'soulTale', phase: 'P1' },
    ],
  },
  {
    id: 'affairs',
    accentRgb: '226,142,112',
    screens: [
      { id: 'sect', phase: 'P1' },
      { id: 'factions', phase: 'P1' },
      { id: 'market', phase: 'P0' },
      { id: 'prodigy', phase: 'P1' },
    ],
  },
];

export function tabDef(id: TabId): TabDef {
  const t = TABS.find((x) => x.id === id);
  if (!t) throw new RangeError(`unknown tab: ${id}`);
  return t;
}

export function isTabId(v: unknown): v is TabId {
  return typeof v === 'string' && (TAB_IDS as readonly string[]).includes(v);
}

export const DEFAULT_TAB: TabId = 'character';
